export const FieldErrorMessages: { [type: string]: { [errorKey: string]: string } } = {
  personName: {
    required: '{fieldName} is required',
    minlength: 'Minimum 2 characters required',
    maxlength: 'Maximum 50 characters allowed',
    pattern: 'Only alphabets and spaces are allowed',
    requiredIfAny: '{fieldName} is required when mobile or email is provided'
  },
  personNameOptional: {
    minlength: 'Minimum 2 characters required',
    maxlength: 'Maximum 50 characters allowed',
    pattern: 'Only alphabets and spaces are allowed',
    requiredIfAny: '{fieldName} is required when mobile or email is provided'
  },
  email: {
    required: 'Email is required',
    email: 'Please enter a valid email address'
  },
  emailOptional: {
    email: 'Please enter a valid email address'
  },
  mobile10: {
    required: '{fieldName} is required',
    pattern: 'Please enter a valid 10-digit mobile number',
    minlength: 'Mobile number must be exactly 10 digits',
    maxlength: 'Mobile number must be exactly 10 digits'
  },
  mobile10Optional: {
    pattern: 'Please enter a valid 10-digit mobile number',
    minlength: 'Mobile number must be exactly 10 digits',
    maxlength: 'Mobile number must be exactly 10 digits'
  },
  alphanumericText: {
    required: '{fieldName} is required',
    minlength: 'Minimum 2 characters required',
    pattern: 'Contains invalid characters'
  },
  schoolName: {
    required: '{fieldName} is required',
    pattern: 'Only alphabets, spaces, commas, and hyphens allowed'
  },
  cityName: {
    required: '{fieldName} is required',
    pattern: 'Only alphabets, spaces, commas, and hyphens allowed'
  },
  description500: {
    required: '{fieldName} is required',
    maxlength: 'Maximum 500 characters allowed'
  },
  yearField: {
    required: 'Year is required', // for education yearsTo conditionally required
    yearRange: '\'To\' year cannot be before \'From\' year',
    yearFuture: 'Year cannot be in the future',
    pattern: 'Must be a valid 4-digit year',
    min: 'Invalid year range',
    max: 'Invalid year range'
  },
  percentageScore: {
    required: 'Grade / Percentage is required',
    pattern: 'Enter a valid score (0-100)',
    min: 'Enter a valid score (0-100)',
    max: 'Enter a valid score (0-100)'
  },
  testScore: {
    pattern: 'Enter a valid score',
    min: 'Enter a valid score',
    max: 'Enter a valid score',
    missingScore_ieltsScore: 'Score is required',
    missingScore_toeflScore: 'Score is required',
    missingScore_duolingoScore: 'Score is required',
    missingScore_apExamScore: 'Score is required',
    missingScore_satScore: 'Score is required',
    missingScore_greTotalScore: 'Score is required',
    missingScore_gmatScore: 'Score is required',
    missingScore_actScore: 'Score is required'
  },
  requiredOnly: {
    required: '{fieldName} is required'
  },
  dobField: {
  required: '{fieldName} is required',
  dobFuture: 'Date of birth cannot be in the future',
  dobAgeRange: 'Age must be between 10 and 100 years'
}
};
